import { nanoid } from '@reduxjs/toolkit'
import { TokenList } from '../utils/token-lists/token-lists.types'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../state'
import { fetchTokenList } from '../state/lists/actions'
import getTokenList from '../utils/getTokenList'
import resolveENSContentHash from '../utils/resolveENSContentHash'
import { useActiveWeb3React } from './index'

export function useFetchListCallback(): (listUrl: string, sendDispatch?: boolean) => Promise<TokenList> {
  const { library } = useActiveWeb3React()
  const dispatch = useDispatch<AppDispatch>()

  return useCallback(
    async (listUrl: string, sendDispatch = true) => {
      if (!library) {
        console.debug('No library available, returning empty list')
        return { tokens: [], name: '', timestamp: '', version: { major: 0, minor: 0, patch: 0 } }
      }
      const requestId = nanoid()
      sendDispatch && dispatch(fetchTokenList.pending({ requestId, url: listUrl }))
      return getTokenList(listUrl, (ensName: string) => resolveENSContentHash(ensName, library))
        .then((tokenList) => {
          sendDispatch && dispatch(fetchTokenList.fulfilled({ url: listUrl, tokenList, requestId }))
          return tokenList
        })
        .catch((error: any) => {
          console.debug(`Failed to get list at url ${listUrl}`, error)
          sendDispatch && dispatch(fetchTokenList.rejected({ url: listUrl, requestId, errorMessage: error.message }))
          return { tokens: [], name: '', timestamp: '', version: { major: 0, minor: 0, patch: 0 } }
        })
    },
    [dispatch, library]
  )
}
